import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { OrderItemPrice } from 'graphql-ts-types';
import { space } from 'styled-system';

import { Flex } from 'common/components/Flex';
import ArticleSmallPrice, { RenderingStrategy } from 'common/components/Price/ArticleSmallPrice';
import { BodyRegularBR2, HeadlineH8 } from 'common/components/Typography';
import { textWithEllipsis } from 'common/theme/styles';
import type { SpaceProps } from 'common/theme/system-types';

interface ProductDetailProps {
  name: string;
  nameId: string;
  variantName: string;
  price: OrderItemPrice;
  isRecommendedRetailPrice?: boolean;
}

const UnstyledProductDetailContainer = styled(Flex)``;

const ProductDetailContainer = (props: ComponentProps<typeof UnstyledProductDetailContainer>) => (
  <UnstyledProductDetailContainer
    ml="sp_8"
    width={[null, 1]}
    flexDirection={['column', 'row']}
    justifyContent={[null, 'space-between']}
    {...props}
  />
);

const UnstyledProductName = styled(HeadlineH8)`
  ${textWithEllipsis(2)};
`;

const ProductName = (props: ComponentProps<typeof UnstyledProductName>) => (
  <UnstyledProductName mb="sp_2" pr="sp_12" {...props} />
);

const ProductVariantName = styled(BodyRegularBR2)`
  ${textWithEllipsis(2)};
`;

const UnstyledPrice = styled(ArticleSmallPrice)<SpaceProps>`
  ${space};
`;

const Price = (props: ComponentProps<typeof UnstyledPrice>) => (
  <UnstyledPrice mt={['sp_4', 'sp_0']} ml={['sp_0', 'sp_8']} {...props} />
);

const ProductDetail = ({ name, nameId, variantName, price }: ProductDetailProps) => {
  return (
    <ProductDetailContainer>
      <div>
        <ProductName id={nameId}>{name}</ProductName>
        <ProductVariantName>{variantName}</ProductVariantName>
      </div>
      <Price regularPrice={price} renderingStrategy={RenderingStrategy.Horizontal} />
    </ProductDetailContainer>
  );
};

export default ProductDetail;
